import { EyeOff } from 'lucide-react'

import { Badge } from '@/components/ui/badge'

const HIDDEN_BADGE_TITLE =
  "Hidden from other organizations' snippets and scripts. Calls still use it."

export function HiddenBadge({ className }: { className?: string }) {
  return (
    <Badge variant="secondary" className={className} title={HIDDEN_BADGE_TITLE}>
      <EyeOff aria-hidden="true" />
      Hidden
    </Badge>
  )
}
